import moment from 'moment'
import { createSelector } from 'reselect'
import { values } from 'lodash'

const _events = state => state.familyAlbum.data

export const eventsDone = state => state.familyAlbum.done
export const eventsError = state => state.familyAlbum.error
export const eventsPending = state => state.familyAlbum.pending

export const sortedEvents = createSelector(
  [_events],
  events => {
    return values(events).sort((a, b) => {
      return moment.utc(b.dateStart).diff(moment.utc(a.dateStart))
    })
  },
)
